module.exports = __webpack_public_path__ + "assets/img/wu_text.8f372d39.png";